function Spacer({ height }) {
  return <div style={{ height }} />;
}
export default Spacer;
